import React, { useState } from 'react';
import { PersonalInfoForm, Spinner } from '@silverrailtech/srtlibrary';
import PropTypes from 'prop-types';
import ExtendedSnackbar from '../../../../components/ExtendedSnackbar/ExtendedSnackbar';

const PersonalInfo = ({
	personalInfo,
	isPersonalDataLoading,
	personalInfoError,
	setError,
	isAgent,
}) => {
	const [isEditing, setIsEditing] = useState(false);

	const props = {
		formData: personalInfo,
		isEditing,
		showEditButton: false,
		setIsEditing,
		onCancel: () => {},
		onSubmit: () => {},
		isAgent,
	};
	// remove !personalInfo when component library fix failed API or handle here with UI
	if (isPersonalDataLoading || !personalInfo) return <Spinner />;
	return (
		<>
			<PersonalInfoForm {...props} />
			<ExtendedSnackbar
				id="srtPersonalInfoSnackBar"
				open={personalInfoError !== ''}
				message={personalInfoError}
				onClose={() => setError('')}
			/>
		</>
	);
};

PersonalInfo.propTypes = {
	personalInfo: PropTypes.object,
	isPersonalDataLoading: PropTypes.bool,
	personalInfoError: PropTypes.string,
	setError: PropTypes.func.isRequired,
	isAgent: PropTypes.bool,
};

export default PersonalInfo;
